import { useReadContract } from 'thirdweb/react'
import useGoldBundleStorageContract from './useCarbonBundleStorageContract'
import { depositFeePercent, withdrawalFeePercent } from 'src/thirdweb/carbon_bundle_storage'

const useCarbonBundleInfo = () => {
  const contract = useGoldBundleStorageContract()

  const depositFee = useReadContract(depositFeePercent, {
    contract,
  })
  const withdrawalFee = useReadContract(withdrawalFeePercent, {
    contract,
  })

  const loading = depositFee.isLoading || withdrawalFee.isLoading

  return {
    carbonBundleInfo: {
      depositFee: depositFee.data,
      withdrawalFee: withdrawalFee.data
    },
    loading,
  }
}

export default useCarbonBundleInfo
